"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var discardFocusedInboxOption_1 = require("./actions/discardFocusedInboxOption");
var saveFocusedInboxOption_1 = require("./actions/saveFocusedInboxOption");
var FocusedFull_1 = require("./components/FocusedFull");
var isFocusedInboxOptionDirty_1 = require("./utils/isFocusedInboxOptionDirty");
var React = require("react");
var owa_session_store_1 = require("owa-session-store");
var FocusedInboxOption = {
    key: 'focused',
    titleStringKey: 'optionTitle_focusedInbox',
    searchTermsStringKey: 'optionTitle_focusedInbox',
    fullOptionFormSettings: {
        render: function () { return React.createElement(FocusedFull_1.default, null); },
        isDirty: isFocusedInboxOptionDirty_1.default,
        onSave: saveFocusedInboxOption_1.default,
        onDiscard: discardFocusedInboxOption_1.default,
    },
    quickOptionSettings: {
        rendering: {
            isToggleOn: function () { return owa_session_store_1.getUserConfiguration().UserOptions.IsFocusedInboxEnabled; },
            onToggle: saveFocusedInboxOption_1.saveFocusedInboxQuickOption,
        },
        order: 3 /* Focused */,
        workloads: 1 /* Mail */,
        tooltip: {
            tooltipStringKey: 'options_focused_enabled',
        },
    },
};
exports.default = FocusedInboxOption;
//# sourceMappingURL=FocusedInboxOption.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-focused-option/lib/FocusedInboxOption.js
// module id = 5086
// module chunks = 2